/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Icon from '@material-ui/core/Icon';
import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DRAFT_VIEW, DraftManagementContext } from '../useDraftManagement';
import { useScreenSize } from '../../../shared/theming/useScreenSize';

const useStyles = makeStyles(theme => ({
  viewToggleButton: {
    marginBottom: '1.5rem',
    '& button': {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      alignSelf: 'flex-end',
      '& button': {
        width: 'unset',
      },
    },
  },
}));

export function LayoutSwitcher() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { view, setView } = useContext(DraftManagementContext);
  const { isLargeOrBigger } = useScreenSize();

  if (isLargeOrBigger) return <div />;

  return (
    <ToggleButtonGroup key="toggleButton" value={view} className={classes.viewToggleButton}>
      <ToggleButton value={DRAFT_VIEW.GRID} onClick={() => setView(DRAFT_VIEW.GRID)}>
        <Icon>apps</Icon>
        {t('actions.view.grid')}
      </ToggleButton>
      <ToggleButton value={DRAFT_VIEW.TABLE} onClick={() => setView(DRAFT_VIEW.TABLE)}>
        <Icon>list</Icon>
        {t('actions.view.list')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
